export const listenToMessagesFromOrigin: ListenToMessagesFromOrigin = (
  listener: (data: any) => void,
  origin: string
): void => {
  window.onmessage = event => {
    if (event.origin === origin) {
      listener(event.data);
    }
  };
};

export const postMessageToIframe = (
  iframeRef: React.RefObject<HTMLIFrameElement>,
  message: string,
  targetOrigin: string
): void => {
  iframeRef.current?.contentWindow?.postMessage(message, targetOrigin);
};
